<template>
  <div class="app app--background-image" id="cube11">
    <CommingSoon/>
  </div>
</template>

<script>
import CommingSoon from './components/CommingSoon.vue'

export default {
  name: 'cube11',
  components: {
    CommingSoon
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,700');
body {
  margin: 0;
  padding: 0;
}
#cube11 {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
}
.app {
  display: flex;
  justify-content: center;
  align-items: center;
  &.app--background-image {
    box-sizing: border-box;
    width: 100%;
    height: 100vh;

    background-image: url('./assets/clouds-conifers-fir-trees-592285.jpg');
    background-position: center;
    background-size: cover;

    padding: 1em;
  }
}
</style>
